import styled from 'styled-components';
import { spacings } from 'styles';

import { Star } from '../PlacesItem/styles';

export const NoFavoritesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h6 {
    margin-bottom: ${spacings.space04};
  }

  p {
    display: flex;
    align-items: center;
    text-align: center;

    ${Star} {
      transform: scale(0.7) translateY(2px);
    }
  }
`;
